(function () {
  $('.skip-links__link').on('keydown', function (e) {
    let ENTER = 13;
    if (e.which === ENTER) {
      e.preventDefault();
      let hash = $(e.target).attr('href');

      let hiddenAnchor = $(hash + ' .hidden-anchor');
      if (!hiddenAnchor.length) {
        hiddenAnchor = $(
          '<a class="hidden-anchor" href="javascript:void(0);" tabindex="-1" aria-hidden="true" style="border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;"/>'
        );
        $(hash).prepend(hiddenAnchor);
      }

      hiddenAnchor.focus();
      let top = $(hash).offset().top;
      $('html, body').stop().animate(
        {
          scrollTop: top
        },
        0
      );

      location.hash = '';
      if (history.pushState) {
        history.replaceState(null, null, hash);
      } else {
        location.hash = hash;
      }
      return;
    }
  });
})();
